import { useContext } from 'react';

import { IVpaasContext, VpaasContext } from './VpaasContext';

/**
 * @returns whether current context is in active VPAAS
 */
export function useIsVpaas(): boolean {
  return useContext(VpaasContext)?.isEnabled === true;
}

/**
 * @returns current vpaas context data
 */
export function useVpaasContext(): IVpaasContext {
  return useContext(VpaasContext);
}
